/**
 * Traducción de códigos de unidad de Arcos a nombre legible.
 *
 * Arcos entrega códigos cortos en el campo `ProductoPresentacionUnd`. Este
 * mapping se aplica en la UI para mostrar textos completos como
 * "Paquete" en lugar de solo "P".
 *
 * Si un código no está mapeado se devuelve el código original en mayúscula.
 * Actualiza este objeto cuando aparezcan nuevas unidades en el ERP.
 */
const UNIT_LABELS = {
  // Códigos observados en el catálogo actual de CM Calidad y Servicio
  B: "Bulto",
  UND: "Unidad",
  D: "Display",
  P: "Paca",
  G: "Gramos",
  LT: "Litros",
  L: "Litros",
  KG: "Kilogramos",
  ML: "Mililitros",
  // Otras comunes por si aparecen
  CJ: "Caja",
  DOC: "Docena",
  PAQ: "Paquete",
  BOL: "Bolsa",
  ROLL: "Rollo",
  GAL: "Galón",
};

/**
 * Devuelve el nombre completo de la unidad para mostrar en UI.
 * Ejemplos: "P" → "Paquete", "Und" → "Unidad", "kg" → "Kilogramos".
 */
export const formatUnit = (code) => {
  if (!code) return "";
  const key = String(code).trim().toUpperCase();
  return UNIT_LABELS[key] || key;
};

/**
 * Devuelve "Paquete (P)" cuando queramos mostrar el nombre + código corto.
 * Útil en la ficha detallada para no perder el código.
 */
export const formatUnitFull = (code) => {
  if (!code) return "";
  const key = String(code).trim().toUpperCase();
  const label = UNIT_LABELS[key];
  if (!label) return key;
  return `${label} (${key})`;
};
